export enum Permissoes {
	Comum = 0,
	AdministradorEmpresa = 1,
	AdministradorSistema = 2,
	// Consultor = 3,
	ConsultorExterno = 4,
}
